import { TextFieldElement, TextFieldElementProps, useFormContext } from 'react-hook-form-mui';

import { isEmpty } from 'lodash';

import { useCurrentProduct } from 'api/products';

type MaxVersionProps = {
    disabled?: boolean;
    name?: string;
};

export function MaxVersion({
    disabled,
    name = 'max_version',
    required = false,
    ...defaultProps
}: Omit<TextFieldElementProps, 'name'> & MaxVersionProps) {
    const { data: currentProduct } = useCurrentProduct();

    const configurationMaxVersion = useFormContext().getValues(name);
    const showMaxVersion = configurationMaxVersion || !disabled;

    function validate(value: string) {
        if (required && isEmpty(value)) {
            return 'This field is required';
        }
        const reg = new RegExp(/^(\d+)(\.(\d+))?(\.(\*|\d+))?$/);
        if (!isEmpty(value) && !reg.test(value)) {
            return 'Invalid version';
        }

        return true;
    }

    if (!currentProduct?.has_max_version) return null;

    if (!showMaxVersion) return null;
    return (
        <TextFieldElement
            label={required ? 'Max Version *' : 'Max Version'}
            name={name}
            placeholder="__.__.__"
            type="text"
            InputLabelProps={{ shrink: true }}
            rules={{ validate: validate }}
            disabled={disabled}
            {...defaultProps}
        />
    );
}
